export const getHostedFileUrl = (path: string) => {
  // If path is already a full URL, return it as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const runtimeConfig = useRuntimeConfig();
  return `${String(runtimeConfig.public.publicStorageFrontdoorUrl).replace(/\/+$/, '')}/${path}`;
};
